import { clsx } from 'clsx';

import styles from './Filter.css';

interface IFilterProps {
  className?: string;
  dataTestId?: string;
  isRedesign?: boolean;
}

export const Filter: React.FC<React.PropsWithChildren<IFilterProps>> = ({
  className,
  children,
  dataTestId,
  isRedesign = false,
}) => {
  return (
    <div
      className={clsx(isRedesign ? styles['redesigned-container'] : styles['container'], className)}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
